
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Building, Users } from 'lucide-react';

export interface ResourceUsageCardsProps {
  totalInstances: number;
  usedInstances: number;
  remainingInstances: number;
  totalAdmins: number;
  usedAdmins: number;
  remainingAdmins: number;
}

const ResourceUsageCards: React.FC<ResourceUsageCardsProps> = ({
  totalInstances,
  usedInstances,
  remainingInstances,
  totalAdmins,
  usedAdmins,
  remainingAdmins
}) => {
  const instancesPercentage = totalInstances > 0 
    ? Math.round((usedInstances / totalInstances) * 100) 
    : 0;
    
  const adminsPercentage = totalAdmins > 0 
    ? Math.round((usedAdmins / totalAdmins) * 100) 
    : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center">
              <Building className="h-5 w-5 mr-2 text-blue-500" />
              <h3 className="font-medium">Instance Usage</h3>
            </div>
            <span className="text-sm font-medium">
              {usedInstances} / {totalInstances}
            </span>
          </div>
          
          <Progress value={instancesPercentage} className="h-2 mb-2" />
          
          <div className="flex justify-between text-sm text-gray-500">
            <span>Used: {usedInstances} instance{usedInstances !== 1 ? 's' : ''}</span>
            <span>Remaining: {remainingInstances}</span>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center">
              <Users className="h-5 w-5 mr-2 text-green-500" />
              <h3 className="font-medium">Admin Managers</h3>
            </div>
            <span className="text-sm font-medium">
              {usedAdmins} / {totalAdmins}
            </span>
          </div>
          
          <Progress value={adminsPercentage} className="h-2 mb-2" />
          
          <div className="flex justify-between text-sm text-gray-500">
            <span>Used: {usedAdmins} manager{usedAdmins !== 1 ? 's' : ''}</span>
            <span>Remaining: {remainingAdmins}</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ResourceUsageCards;
